import Kegiatan from "../../../../../components/categories/siakad/lms/data_matpel/subpage/kegiatan/Home";
export default function Home() {
  
  return (
    <Kegiatan />
  );
}
